import Detail from '../../../../components/Detail';
import InfoPopUp from '../../../../components/InfoPopUp';
import { formatUSD } from '../../../../helpers/formats';
import usePendingAmounts from '../../../../hooks/web3/vault/usePendingAmounts';

const PendingWithdrawals: React.FC = () => {
    const { pendingAmounts } = usePendingAmounts();

    const pending = pendingAmounts
        ? Object.entries(pendingAmounts.spools).filter(
              ([_, { pendingWithdrawalAmount }]) => pendingWithdrawalAmount !== 0
          )
        : [];

    return (
        <Detail
            title={
                <>
                    <span>Your Pending Withdrawals</span>
                    <InfoPopUp>
                        <span>Pending Withdrawals:</span>
                        {pending.length ? (
                            pending.map(([spoolAddress, pendingWithdrawal]) => (
                                <div key={spoolAddress} className='mt'>
                                    <span className='block'>
                                        {pendingWithdrawal.spoolDetails?.spoolName ??
                                            'Spool'}
                                    </span>
                                    <strong className='block'>
                                        {formatUSD(
                                            pendingWithdrawal?.pendingWithdrawalAmount ||
                                                0
                                        )}{' '}
                                        {pendingWithdrawal.spoolDetails?.underlying
                                            ?.symbol ?? 'Asset'}
                                    </strong>
                                </div>
                            ))
                        ) : (
                            <strong className='block'>N/A</strong>
                        )}
                    </InfoPopUp>
                </>
            }
            value={`~$${formatUSD(pendingAmounts?.total?.pendingWithdrawalAmount || 0)}`}
        />
    );
};

export default PendingWithdrawals;
